import {useMutation, useQueryClient} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {BackendResponse} from '@common/http/backend-response/backend-response';

import {CreateCategoryPayload} from '@app/blog/category/use-create-category';



export type UpdateCategoryPayload = Partial<CreateCategoryPayload>;

export function useUpdateCategory(
  projectId: number,
  form: UseFormReturn<UpdateCategoryPayload>,
) {
  const {trans} = useTrans();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: UpdateCategoryPayload) =>
      updateCategory(projectId, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['categories']});
      toast(trans(message('Category updated')));
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function updateCategory(
  projectId: number | string,
  payload: UpdateCategoryPayload,
) {
  return apiClient
    .put<Response>(`categories/${projectId}`, payload)
    .then(r => r.data);
}
